// src/services/Firebase.js
import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyD0JhDTbzSMzFm3rJ7HiNMgVgwzEmVbVYA",
  authDomain: "pereodictablefree.firebaseapp.com",
  databaseURL: "https://pereodictablefree.firebaseio.com",
  projectId: "pereodictablefree",
  storageBucket: "pereodictablefree.appspot.com",
  messagingSenderId: "341642081163",
  appId: "1:341642081163:web:94f187af0c9b390e3f358e",
  measurementId: "G-1NLRQGGCVP"
};

export const app = initializeApp(firebaseConfig);

// analytics может быть недоступен (SSR, приватный режим, неподдерживаемый браузер),
// поэтому проверяем isSupported() и инициализируем асинхронно.
export let analytics = null;

export const analyticsReady = isSupported()
  .then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    } else {
      // eslint-disable-next-line no-console
      console.warn('[Analytics] не поддерживается в этом окружении');
    }
    return analytics;
  })
  .catch(() => null);